document.addEventListener('DOMContentLoaded', function () {
    var swiperEl = document.querySelector('#portfolio-swiper');
    if (!swiperEl) {
        console.warn('Portfolio carousel not found');
        return;
    }

    if (typeof Swiper === 'undefined') {
        console.error('Swiper library is not loaded');
        return;
    }

    var dots = document.querySelectorAll('.portfolio-dot');

    function updateDots(activeIndex) {
        for (var i = 0; i < dots.length; i++) {
            if (i === activeIndex) {
                dots[i].classList.add('active');
            } else {
                dots[i].classList.remove('active');
            }
        }
    }

    function animateCards(swiper) {
        var activeSlide = swiper.slides[swiper.activeIndex];
        if (!activeSlide) return;

        var cards = activeSlide.querySelectorAll('.brand-card');
        for (var i = 0; i < cards.length; i++) {
            (function(card, index) {
                card.style.animation = 'none';
                card.offsetHeight;
                card.style.animation = 'slideUpCard 0.6s ease-out ' + (index * 0.2 + 0.1) + 's both';
            })(cards[i], i);
        }
    }

    var portfolioSwiper = new Swiper('#portfolio-swiper', {
        direction: 'vertical',
        loop: true,
        speed: 900,
        slidesPerView: 'auto',
        spaceBetween: -10,
        centeredSlides: true,
        grabCursor: true,
        allowTouchMove: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        updateOnWindowResize: true,
        loopAdditionalSlides: 3,

        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        },

        mousewheel: {
            invert: false,
            releaseOnEdges: true,
        },
        

        a11y: {
            enabled: true,
        },

        on: {
            slideChange: function () {
                updateDots(this.realIndex);
                animateCards(this);
            },
            init: function () {
                this.slideToLoop(0, 0, false);
                updateDots(this.realIndex);
                animateCards(this);
            }
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 12,
            },
            1024: {
                slidesPerView: 'auto',
                spaceBetween: -10,
            }
        }
    });

    portfolioSwiper.update();
    portfolioSwiper.slideToLoop(0, 0, false);

    for (var i = 0; i < dots.length; i++) {
        (function(dot) {
            dot.addEventListener('click', function () {
                var index = parseInt(this.getAttribute('data-index'));
                portfolioSwiper.slideToLoop(index);
            });
        })(dots[i]);
    }

    var bgImage = document.querySelector('.portfolio-bg-image');
    if (bgImage) {
        var ticking = false;
        window.addEventListener('scroll', function () {
            if (!ticking) {
                window.requestAnimationFrame(function () {
                    var section = document.querySelector('.portfolio-brands');
                    if (!section) return;

                    var rect = section.getBoundingClientRect();
                    var windowH = window.innerHeight;

                    if (rect.top < windowH && rect.bottom > 0) {
                        var scrollProgress = (windowH - rect.top) / (windowH + rect.height);
                        var translateY = (scrollProgress - 0.5) * 60;
                        bgImage.style.transform = 'scale(1.05) translateY(' + translateY + 'px)';
                    }

                    ticking = false;
                });
                ticking = true;
            }
        });
    }

    swiperEl.setAttribute('tabindex', '0');
    swiperEl.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            portfolioSwiper.slidePrev();
            e.preventDefault();
        }
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            portfolioSwiper.slideNext();
            e.preventDefault();
        }
    });
});
